'use strict'

import $ from 'jquery'

export default function () {
    // Accordion
    if ( $('.accordion').length >= 0 ) {
        const $title = $('.accordion__button')
        const $panel = $('.accordion__content')

        $title.on('click', function() {
            const $sibling = $(this).parent().siblings('.accordion__content')
            const $wrapper = $($(this).parents()[2])

            const isOpening = $(this).attr('aria-expanded') === 'false';

            $(this).parents('.accordion').toggleClass('is-active')
            $(this).attr('aria-expanded', (i, attr) => 'true' === attr ? 'false' : 'true')
            $sibling.slideToggle()

            if ( ! $wrapper.data('multiple') ) {
                $title.not(this).attr('aria-expanded', 'false')
                $title.not(this).parents('.accordion').removeClass('is-active').attr('aria-expanded', 'false')
                $panel.not($sibling).slideUp()
            }

            // Si le parent est en train de s'ouvrir, on ouvre aussi tous les enfants
            if (isOpening) {
                $sibling.find('.accordion__button').each(function() {
                    $(this).attr('aria-expanded', 'true');
                    $(this).parents('.accordion').addClass('is-active');
                    $(this).parent().siblings('.accordion__content').slideDown();
                });
            } else {
                // Sinon, on ferme tous les enfants si le parent se ferme
                $sibling.find('.accordion__button').each(function() {
                    $(this).attr('aria-expanded', 'false');
                    $(this).parents('.accordion').removeClass('is-active');
                    $(this).parent().siblings('.accordion__content').slideUp();
                });
            }
        })
    }
}
